import styled from "styled-components";

export const Spinner = styled.div<{ size: number }>`
  width: ${(props: { size?: number }) => `${props.size ?? 36}px`};
  height: ${(props: { size?: number }) => `${props.size ?? 36}px`};
  background: conic-gradient(
    from 180deg at 50% 50%,
    #4285f4 0deg,
    rgba(16, 24, 40, 0) 360deg
  );
  transform: rotate(0deg);

  display: flex;
  justify-content: center;
  align-items: center;
  border-radius: 100%;
  animation: loadingAnimation 0.9s linear infinite;

  :after {
    content: "";
    background: white;
    width: 75%;
    height: 75%;
    border-radius: 100%;
  }

  @keyframes loadingAnimation {
    0% {
      transform: rotate(0deg);
    }
    100% {
      transform: rotate(360deg);
    }
  }
`;
